import { IOpenHoleLoggingCost } from '../../interfaces/iopen-hole-logging-cost';
import { UnitOfMeasure } from '../unit-of-measure';
import { Vendor } from '../vendor';

export class OpenHoleLoggingCostBase {
  OpenHoleLoggingCostId: number;
  VendorId: number;
  DrillingItemId: number;
  UnitCost: number;
  UnitOfMeasureId: number;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  UnitOfMeasure?: UnitOfMeasure;
  Vendor?: Vendor;

  constructor(item?: IOpenHoleLoggingCost) {
    if (item) {

      this.OpenHoleLoggingCostId = item.OpenHoleLoggingCostId;
      this.VendorId = item.VendorId;
      this.DrillingItemId = item.DrillingItemId;
      this.UnitCost = item.UnitCost;
      this.UnitOfMeasureId = item.UnitOfMeasureId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.UnitOfMeasure = new UnitOfMeasure(item.UnitOfMeasure);
      this.Vendor = new Vendor(item.Vendor);
    }
  }
}